import  React, {useState} from 'react';
// import logo from "./images/Logo_Orginal.png";
// import category_grocery from "./images/category_grocery.png";
// import category_textile from "./images/category_textile.png";
// import category_saloon from "./images/category_saloon.png";
// import category_beauty_parlour from "./images/category_beauty_parlour.png";
// import category_gym from "./images/category_gym.png";
// import category_Opticals from "./images/category_Opticals.png";
// import category_supermarket from "./images/category_supermarket.png";
// import category_Mobile from "./images/category_Mobile.png";
// import what_is_ghoshak_img from "./images/what_is_ghoshak_img.png";
// import why_ghoshak_1 from "./images/why_ghoshak_1.png";
// import why_ghoshak_2 from "./images/why_ghoshak_2.png";
// import why_ghoshak_3 from "./images/why_ghoshak_3.png";
// import customer_app from "./images/customer_app.png";
// import bussiness_app from "./images/bussiness_app.png";
// import play_store from "./images/play_store.png";
// import our_feature_offers from "./images/our_feature_offers.png";
// import our_feature_collection from "./images/our_feature_collection.png";
// import our_feature_loyalty_point from "./images/our_feature_loyalty_point.png";
// import our_feature_coupon from "./images/our_feature_coupon.png";
// import our_feature_appintment from "./images/our_feature_appintment.png";
// import our_client_say_img from "./images/our_client_say_img.png";
// import our_client_say_comma from "./images/our_client_say_comma.png";

import Footer from "./footer"
import HeaderNavbar from "./header-navbar"
import "react-multi-carousel/lib/styles.css";

// import Carousel from "react-multi-carousel";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
// import {
//   faFacebookF,
//   faGooglePlusG,
//   faTwitter,
//   faYoutube,
//   faInstagram
// } from "@fortawesome/free-brands-svg-icons";
import {  Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

const ourFeaturesCarouselResponsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 7
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 5
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 4
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 3
  }
};

const ourOurClientSayResponsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 1
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};

function App() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <div className="body full-width float-left">
      <div  className="header other-page-header" id="home">
        <HeaderNavbar />
      </div>
      <div class="terms_conditions">
        <div class="container">
          <div class="vertical-space-30"></div>
          <p>
            <strong>AGREEMENT CONTAINING TERMS OF USE</strong> (Please read the
            contents very carefully before you click the “I ACCEPT” icon at the
            end of the Agreement)
          </p>
          <h3 class="text-center">Terms of Use Agreement</h3>
          <p>	This Terms of Use Agreement (this “Agreement”) is entered into by and between Zoryboard Software Solutions Private Limited. (the “Author”) having CIN U93090TN2018PTC126441 and “you,” the user of this app, known as the “Ghoshak” (the “App”). Access to, downloading, use of and/or accessing the App is provided subject to the terms and conditions set forth herein. By accessing, downloading or using the App, you hereby expressly agree to these terms and conditions. Therefore, it is mandatory that only if you have attained the age of majority and the competence to enter into a contract, you can download, access or otherwise use the App. In addition, any usage / subsequent usage of the App which you have downloaded or accessed by any person who is below the age of majority should be strictly under parental / adult guidance and supervision.
          </p>
          <p>
            THIS AGREEMENT CONTAINS WARRANTY DISCLAIMERS AND OTHER PROVISIONS THAT
            LIMIT THE AUTHOR’S LIABILITY TO YOU IN RELATION TO ALL ASPECTS OF THE
            APP. PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY AND IN THEIR
            ENTIRETY, AS DOWNLOADING, USING OR ACCESSING THE APP CONSTITUTES
            ACCEPTANCE OF THESE TERMS AND CONDITIONS. IF YOU DO NOT AGREE TO BE
            BOUND TO EACH AND EVERY TERM AND CONDITION SET FORTH HEREIN, PLEASE
            REFRAIN FROM DOWNLOADING, USING AND ACCESSINGTHE APP IMMEDIATELY AND
            DO NOT USE, DOWNLOAD, ACCESS OR READ THE APP OR ANY OF ITS CONTENTS.
          </p>
          <p>
            BY DOWNLOADING OR ACCESSING OR OTHERWISE VIEWING / USING THE APP, YOU
            FULLY ACKNOWLEDGE AND AGREE THAT YOU HAVE FULLY READ AND UNDERSTAND
            THESE TERMS AND CONDITIONS, THAT THE PROVISIONS, DISCLOSURES AND
            DISCLAIMERS SET FORTH HEREIN ARE FAIR, REASONABLE AND AGREEABLE, AND
            THAT YOUR AGREEMENT TO FOLLOW AND BE BOUND BY THESE TERMS AND
            CONDITIONS IS FULLY VOLUNTARY ON YOUR PART ON YOUR OWN ACCORD AND IS
            NOT RESULT OF COERCION, DURESS OR UNDUE INFLUENCE EXERCISED UPON YOU
            BY ANY PERSON OR ENTITY.
          </p>
          <h4>GENERAL</h4>
          <p>	Registration and user Accounts: In order to use the App, you must register for and maintain an active services account (“Account”). Unless otherwise expressly agreed, you are allowed to maintain only one account. Registration process requires you to submit to certain personal information, such as your name, address, date of birth, anniversary , gender , mobile phone number, email address, preferences and other personal and business details ,. You fully agree to maintain accurate, complete, and up-to-date information in your Account. Your failure to maintain accurate, complete, and up-to-date Account informationmay result in your inability to access and use the App and the Author shall be fully entitled to suspend, terminate or otherwise deactivate the services of the Account, either permanently or otherwise. You are fully responsible to maintain security and secrecy of your Account and other details and shall be fully responsible for all activity that occurs under your Account. The right to use the App is personal and is not transferable to any person without the express permission from the Author. You also fully acknowledge that the Author shall not in any manner whatsoever be responsible or liable for any interruption in services or events and the author shall not be responsible for any data lost while transmitting information. You also acknowledge that the services and / or the App may be unavailable from time to time for any reason, including but not limited to maintenance, data issue etc. You understand and acknowledge that due to circumstances both within and outside of the control of the Author, access to the App and / or the services may be interrupted, suspended or terminated from time to time. The Author reserves the right, in its sole discretion, to terminate the access to any or all the related services or any portion thereof at any time, without notice and it shall also have the right at any time to change or discontinue any aspect or feature, including, but not limited to, content, graphics, images, offers, settings, hours of availability and equipment and technical specifications needed for download, access or use. The Author makes no warranty to the users for the quality, safety, usability, or another aspect of the product or service for which the coupons, voucher, loyalty points, coupon codes, promotional offers, any promo code etc may be redeemed and the user takes responsibility for his or her own actions in utilizing the services for which same can be redeemed or used.</p>
          <p>The Author provides an interactive online service owned and operated by it through the App (and through website, if any). The Service rendered by the Author is to provide you with an online marketplace to identify, locate and interact with third party Vendors [“Vendors”] of a variety of consumable products [“Products”] and / or Services. The App provides you with details of the Products / Services based on your location and the Vendors within such geographic location. The details of the Products / Services including their quality, quantity and other relevant details are all provided by the individual Vendors and updated from time to time. You acknowledge and understand that the Author does not provide any of this information nor take orders for the purchase of the Products / Services nor delivery of such Products / Fulfilment of services. The Authors role is to facilitate your access to Vendors in your geographic location, provide you with details of their Products / Services and communicate your requirements for the purchase of Products / Services to the Vendors. Actual sales of the Products / Services , delivery of the Products / fulfillment of the services and payment for the sale of such Products / Services are between you and the Vendor. You understand that the Author has business relationships with Vendors, that provide services in relation to creation, production or distribution of content, third parties that provide advertising services and third parties that perform function on behalf of the author for engaging in administrative and / or promotional activities etc.</p>
          <p>
            The services by the Author do not include the provision of a mobile
            phone, computer or other necessary equipment or facility to access the
            App. To use the App and the services thereof, you will require
            appropriate equipment, hardware, software, internet connectivity and
            appropriate telecommunication links and you shall pay all charges
            related thereto. The Author shall not in any manner be liable for any
            damages to your equipment resulting from the use of the App or the
            services.
          </p>
          <h4>Privacy</h4>
          <p>
            Please review our Privacy Policy, which also governs your usage, to
            understand our practices. The personal information / data provided to
            us by you during the course of usage of will be treated as strictly
            confidential and in accordance with the Privacy Notice and applicable
            laws and regulations. If you object to your information being
            transferred or used, please do not use the website.
          </p>
          <h4>E-Platform for Communication</h4>
          <p>	You agree, understand and acknowledge that it is an online platform that enables you to identify Vendors in your geographic location who have Products / Services which you might be interested in purchasing.. You further agree and acknowledge that Author is only a facilitator and is not and cannot be a party to or control in any manner any transactions on the website. Accordingly, the contract of sale of products / services on the website shall be a strictly bipartite contract between you and the sellers on Author</p>
          <h4>Access</h4>
          <p>
            We will do our utmost to ensure that availability of the website will
            be uninterrupted and that transmissions will be error-free. However,
            due to the nature of the Internet, this cannot be guaranteed. Also,
            your access to the website may also be occasionally suspended or
            restricted to allow for repairs, maintenance, or the introduction of
            new facilities or services at any time without prior notice. We will
            attempt to limit the frequency and duration of any such suspension or
            restriction.
          </p>
          <h4>Licence for access</h4>
          <p>Subject to your compliance with these Conditions of Use and payment of applicable fees, if any, Author grants you a non-exclusive, revocable, limited licence to access and make personal use of this website, but not to download (other than page caching) or modify it, or any portion of it, except with express written consent of Author and / or its affiliates, as may be applicable. This licence does not include any resale or commercial use of this website or its contents; any collection and use of any product listings, services listings, descriptions, or prices; any derivative use of this website or its contents; any downloading or copying of account information for the benefit of another seller; or any use of data mining, robots, or similar data gathering and extraction tools. </p>
          <p>
            This App (including but not limited to any copyrighted material,
            trademarks, or other proprietary information) may not be reproduced,
            duplicated, copied, sold, resold, visited, distributed or otherwise
            exploited for any commercial purpose without express written consent
            of Author and / or its affiliates, as may be applicable.
          </p>
          <p>
            You may not frame or use framing techniques to enclose any trademark,
            logo, or other proprietary information (including images, text, page
            layout, or form) of Author and its affiliates without express written
            consent. You may not use any meta tags or any other "hidden text"
            utilising Author’s or its affiliates' names or trademarks without the
            express written consent of Author and / or its affiliates, as
            applicable. Any unauthorised use terminates the permission or license
            granted by Author and / or its affiliates, as applicable.
          </p>
          <h4>FINANCIAL, LEGAL AND OTHER PROFESSIONAL ADVICE DISCLAIMER</h4>
          <p>
            You hereby acknowledge that nothing contained in the App shall
            constitute financial, investment, legal, business, or other
            professional advice and that no professional relationship of any kind
            is created between you and the Author. You hereby agree that you shall
            not make any financial, investment, business, legal or other decision
            based on the whole or any part of anything contained in the App.
          </p>
          <h4>INFORMATION DISCLAIMER</h4>
          <p>
            The write up and opinions expressed in the App are not necessarily the
            opinions of the Author and the App is created by the Author through
            its employees and consultants and the users can fill in the contents
            to the App, which are not specifically edited by the Author and as a
            result, the appropriateness thereof may not be attributed to the
            Author.
          </p>
          <p>
            Any opinions or view of the Author in the App are or have been
            rendered based on specific facts, under certain conditions, and
            subject to certain presumptions or assumptions, which may not be valid
            under all circumstances, and may not and should not be used or relied
            upon for any other purpose, including, but not limited to, for use in
            or in connection with any legal proceeding or any situation or
            condition and the same shall always require appropriate professional
            advices from the experts in the field.
          </p>
          <p>
            The Information contained in the App may be changed without notice and
            is not guaranteed to be complete, correct, error-free, timely, current
            or up-to-date. Similar to any printed materials, the Information may
            become out-of-date. The Author undertakes no obligation to update any
            Information on the App; provided, however, that the Author may update
            the Information or withdraw the App fully or in part at any time
            without any notice, in the Author’s sole and absolute discretion.
            Accordingly, Author reserves the right to make alterations or
            deletions to the Information or the App or withdraw it either in full
            or in part, at any time without notice.
          </p>
          <h4>POSTING GUIDELINES</h4><h4>Your Conduct</h4>
          <p>
            You must not use the website in any way that causes, or is likely to
            cause, the website or access to it to be interrupted, damaged or
            impaired in any way You understand that you, and not Author, are
            responsible for all electronic communications and content sent from
            your computer to us and you must use the website for lawful purposes
            only. You must not use the website for any of the following:
          </p>
          <ul>
            <li>	for fraudulent purposes, or in connection with a criminal offense or other unlawful activity
            </li>
            <li>to send, use or reuse any material that does not belong to you; or is illegal, offensive (including but not limited to material that is sexually explicit content or which promotes racism, bigotry, hatred or physical harm), deceptive, misleading, abusive, indecent, harassing, blasphemous, defamatory, libelous, obscene, pornographic, ethnically objectionable, disparaging or in breach of copyright, trademark, confidentiality, privacy or any other proprietary information or right; or is otherwise injurious to third parties; or relates to or promotes money laundering or gambling; or is harmful to minors in any way; or impersonates another person; or threatens the unity, integrity, security or sovereignty of India or friendly relations with foreign States; or objectionable or otherwise unlawful in any manner whatsoever; or which consists of or contains software viruses, political campaigning, commercial solicitation, chain letters, mass mailings or any "spam</li>
            <li>to cause annoyance, inconvenience or needless anxiety</li>
          </ul>
          <h4>Reviews, comments, communications and other content</h4>
          <p>Users of this App may post reviews, comments and other content on the nature of services rendered by the Vendors; send communications; and submit suggestions, ideas, comments, questions, or other information, as long as the content is not illegal, obscene, abusive, threatening, defamatory, invasive of privacy, infringing of intellectual property rights, or otherwise injurious to third parties, or objectionable and does not consist of or contain software viruses, political campaigning, commercial solicitation, chain letters, mass mailings, or any form of "spam." In the event a user uses a false e-mail address, impersonates any person or entity, or otherwise misleads as to the origin of any content. Author reserves the right (but not the obligation) to remove, refuse, delete or edit any content that in the sole judgement of Author violates these Conditions of use and, or terminate your permission to access or use this website.</p>
          <p>
            If you do post content or submit material, and unless we indicate
            otherwise, you
          </p>
          <ul class="list-unstyled">
            <li>(a) grant Author and its affiliates a non-exclusive, royalty-free, irrevocable, perpetual and fully sublicensable rights to use, reproduce, modify, adapt, publish, translate, create derivative works from, distribute, and display such content throughout the world in any media; and</li>
            <p>
              (b) Author and its affiliates and sublicensees the right to use the
              name that you submit in connection with such content, if they
              choose.
            </p>
          </ul>
          <p>
            You agree that the rights you grant above are irrevocable during the
            entire period of protection of your intellectual property rights
            associated with such content and material. You agree to waive your
            right to be identified as the author of such content and your right to
            object to derogatory treatment of such content. You agree to perform
            all further acts necessary to perfect any of the above rights granted
            by you to Author, including the execution of deeds and documents, at
            its request.
          </p>
          <p>
            You represent and warrant that you own or otherwise control all of the
            rights to the content that you post or that you otherwise provide on
            or through the website; that, as at the date that the content or
            material is submitted to Author: (i) the content and material is
            accurate; (ii) use of the content and material you supply does not
            breach any applicable Author policies or guidelines and will not cause
            injury to any person or entity (including that the content or material
            is not defamatory); (iii) the content is lawful. You agree to
            indemnify Author and its affiliates for all claims brought by a third
            party against it or its affiliates arising out of or in connection
            with a breach of any of these warranties.
          </p>
          <h4>PROMOTIONAL ACTIVITIES</h4>
          <p>
            The Author may, in its sole discretion, create promotional codes,
            promotional offers, coupons etc, that may be redeemed for account
            credit, or other features or benefits related to the services and/or
            any related services, subject to any additional terms that the Author
            may establish. You agree that such promotional codes are at the
            absolute discretion of the Author and the same may be modified,
            terminated or extended by the Author as it may deem fit and such
            promotional codes (i) must be used in a lawful manner and for the
            intended audience and purpose; (ii) shall be duplicated, sold or
            transferred in any manner, or made available to the general public,
            unless expressly permitted by the Author; and (iii) shall be strictly
            subject to the terms and conditions specified by the Author and may be
            disabled by the Author at any time for any reason without liability to
            it. The Author is fully entitled to withhold or deduct credits or
            other features or benefits obtained through the use of promotional
            codes by you or any other user in the event that the Author believes
            that the use or redemption thereof was in error, fraudulent, illegal,
            or in violation of the applicable terms or these terms.
          </p>
          <h4>
            DISCLAIMERS
          </h4>
          <ol type="A">
            <li>
              <strong>GENERAL</strong>
              <p>
                The data contained in this app, including the text, images, and
                graphics, animation, 3D Models, Interactivities, Assessments are
                for informational purposes only. Use of this App is not intended
                to be a substitute for professional advice, endorsement, warranty,
                guarantee, opinion or judgment and you should promptly contact
                your advisor and / or the concerned professional regarding any
                conditions or questions that you may have. This App does not offer
                any opinion or advice, and nothing contained in the content is
                intended to constitute or provide any professional advice. The
                information contained in this App delivers information for general
                knowledge purpose only. The Author accepts no responsibility for
                the correctness of any opinion formed or decisions made based on
                any information provided in or by the use of, this App. We reserve
                the right to block access to and/or to edit or remove any material
                which in our reasonable opinion may give rise to a breach of this
                Agreement. BY DOWNLOADING, ACCESSING, OR USING THE APP, YOU FULLY
                UNDERSTAND AND ACKNOWLEDGE THAT THERE IS NO PROFESSIONAL
                RELATIONSHIP BETWEEN YOU AND THE AUTHOR.
              </p>
              <p>
                Although due care has been taken in compiling and checking the
                information contained in the App to ensure accuracy, the Author,
                its employees, sponsors, consultants, servants or agents shall not
                be responsible or in any way liable for any errors, omissions,
                distortions or inaccuracies in the App or the information
                contained therein, whether arising from negligence or otherwise,
                including any consequences arising therefrom.
              </p>
              <p>	We reserve the right to change, modify substitute, suspend or remove without notice any information or coupon, voucher, loyalty points, coupons, promotional offers, any promo code, which the Author may, in its sole discretion, offer or service from time to time. Your access to the services or the App may also be occasionally restricted to allow for repairs, maintenance or the introduction of new facilities or services. We will attempt to restore such access as soon as we reasonably can. We assume no responsibility for functionality which is dependent on your equipment or other third party software to operate. For the avoidance of doubt, we may also, in our sole discretion, withdraw any information or coupon or voucher or loyalty points, promo code at any time.</p>
              <p>
                This disclaimer of liability applies to any damages or injury
                caused by any failure of performance, error, omission,
                interruption, deletion, defect, delay in operation or
                transmission, computer virus, communication line failure, theft or
                destruction or unauthorized access to, alteration of, or use of
                record, whether for breach of contract, tortuous behavior,
                negligence, or under any other cause of action. The User
                specifically acknowledges that the Author is not liable for the
                defamatory, offensive or illegal conduct of other users or
                third-parties and that the risk of injury from the foregoing rests
                entirely with the User.
              </p>
              <p>	You acknowledge and agree that the Author is not involved in or engaged in receiving payments for the sale of Products / Services nor the delivery of such Products / Fulfillment of Services on the App. </p>
              <p>We shall not be liable in any manner whatsoever in respect of any loss or damage arising, directly or indirectly, out of the decline or other issues in relation to authorisation of any payment transaction or bank related transactions, claims etc.</p>
            </li>
            <li>
              <strong>	DISCLAIMER OF WARRANTIES</strong>
              <p>
                THIS APP AND ITS CONTENT ARE PROVIDED "AS IS” AND “AS AVAILABLE”
                BASIS WITHOUT ANY REPRESENTATION OR WARRANTY OF WHATSOEVER NATURE.
                THE AUTHOR MAKES NO REPRESENTATIONS OR ENDORSEMENT ABOUT THE
                SUITABILITY FOR ANY PURPOSE OF THE INFORMATION OR DETAILS
                AVAILABLE THROUGH THIS APP. THE AUTHOR DOES NOT GUARANTEE THE
                TIMELINESS, VALIDITY, COMPLETENESS, OR ACCURACY OF THE CONTENT OR
                THAT THE INFORMATION MAY BE RELIED UPON FOR ANY REASON OR THAT THE
                INFORMATION WILL BE UNINTERRUPTED OR ERROR FREE OR THAT ANY
                DEFECTS CAN OR WILL BE CORRECTED. TO THE FULLEST EXTENT PERMITTED
                OR ALLOWED UNDER APPLICABLE LAW, WE DISCLAIM ALL WARRANTIES AND
                CONDITIONS, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
                TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
                PURPOSE, TITLE, AND NON-INFRINGEMENT, WITH REGARD TO THE CONTENT,
                PRODUCTS, SERVICES, AND ALL OTHER INFORMATION CONTAINED IN AND/OR
                MADE AVAILABLE THROUGH THIS APP, INCLUDING BUT NOT LIMITED TO THE
                AVAILABILITY OF THIS APP. ALTHOUGH WE MAY UPDATE THE CONTENT ON
                THIS APP FROM TIME TO TIME, PLEASE NOTE THAT INFORMATION CHANGES
                RAPIDLY. THEREFORE, SOME OF THE INFORMATION MAY BE OUT OF DATE
                AND/OR MAY CONTAIN ERRORS.
              </p>
              <p>
                The App may contain graphic - or other -related materials. If you
                find these materials offensive, you may not want to use this App.
              </p>
              <p>
                Without limiting the generality of the foregoing, the Author makes
                no representations or warranties with respect to any Information
                offered or provided within or through the App to be used or be
                suitable for any conditions, action, or application or any other
                similar use or decision making.
              </p>
            </li>
            <li>
              <strong>	DISCLAIMER OF ALL CONSEQUENCES</strong>
              <p>
                Under no circumstances, as a result of your use of the App, will
                the Author be liable to you or to any other person for any direct,
                indirect, special, incidental, exemplary, consequential or other
                damages under any legal theory, including, without limitation,
                tort, contract, strict liability or otherwise, even if advised of
                the possibility of such damages. Without limiting the generality
                of the foregoing, the Author shall have absolutely no liability in
                connection with the App for:
              </p>
              <ol>
                <li>
                  damages as a result of lost profits, loss of good will, work
                  stoppage, failure of performance, delays in operation or
                  transmission, non-delivery of information, deletion of files,
                  mistakes, defects, errors, interruptions or computer failure or
                  malfunction; or
                </li>
                <li>
                  any loss or injury caused, in whole or in part, by the Author’s
                  actions, omissions, or negligence, or for contingencies beyond
                  the Author’s control or knowledge, in procuring, compiling, or
                  delivering the Information; or
                </li>
                <li>
                  any errors, omissions, or inaccuracies in the Information
                  regardless of how caused, or delays or interruptions in delivery
                  of the Information; or
                </li>
                <li>
                  any decision made or action taken or not taken in reliance upon
                  the Information; or
                </li>
                <li>
                  any injury, adverse health condition or similar other
                  consequences encountered or suffered by any user of the App due
                  to the App or any contents therein; or
                </li>
                <li>any other consequence of what so ever nature.</li>
              </ol>
            </li>
          </ol>
          <h4>FORBIDDEN USES:</h4>
          <p>
            The following acts and deeds are, inter-alia, expressly prohibited and
            you expressly undertake not to do (directly or indirectly or to permit
            anyone else to do) any of the following:
          </p>
          <ol>
            <li>
              furnish false data including false names, addresses and contact
              details and fraudulent use of credit/debit card numbers, business
              details etc;
            </li>
            <li>
              send unsolicited mails, messages, posts etc., including the sending
              of "junk mail" or other advertising material to individuals who did
              not specifically request such material;
            </li>
            <li>
              attempt to circumvent our security or network including accessing
              data not intended for you, logging into a server or Account you are
              not expressly authorized to access, or probe the security of other
              networks or access the App in such a way as to, or commit any act
              that would or does, impose an unreasonable or disproportionately
              large burden on our infrastructure or that otherwise interrupts or
              interferes with its functionality, efficiency or operation;
            </li>
            <li>
              directly or indirectly creating chain letters, multi-level marketing
              or other pyramid schemes of any type, whether or not the recipient
              wishes to receive such mailings;
            </li>
            <li>
              enter into fraudulent interactions or transactions with us, a Seller
              or a Merchant (which shall include entering into interactions or
              transactions purportedly on behalf of a third party where you have
              no authority to bind that third party or you are pretending to be a
              third party);
            </li>
            <li>
              use the Services or Site (or any relevant functionality of either of
              them) in breach of this Agreement;
            </li>
            <li>
              engage in any unlawful or criminal activity in connection with the
              use of the services and/or the App or any coupon, voucher, loyalty
              points, coupons, promotional offers or any promo code; or
            </li>
            <lio
              >any act, deed or conduct, which the Author, in its exclusive
              discretion, construes to be in breach of the terms and / or any
              law.</lio
            >
          </ol>
          <h4>INTELLECTUAL PROPERTY</h4>
          <p>
            The Author grants you a limited, personal, non-transferable,
            non-exclusive, revocable license to access and use the services and
            App pursuant to this Agreement and to any additional terms and
            policies set forth by the Author. All Intellectual Property Rights
            (including all copyright, patents, trademarks, service marks, trade
            names, designs) whether registered or unregistered, information
            content or accessed as part of the service, any database operated by
            us and all the Website design, text and graphics, software, photos,
            video, music, sound, and their selection and arrangement, and all
            software compilations, underlying source code and software (including
            applets and scripts) shall remain our property (or that of our
            licensors). You shall not, and shall not attempt to, obtain any title
            to any such intellectual property and shall not be reproduced or
            redistributed or copied, distributed, republished, downloaded,
            displayed, posted or transmitted in any form or by any means, sold,
            rented or sub-licensed, used to create derivative works, or in any way
            exploited without our prior express written permission.
          </p>
          <p>
            The App, Author’s logos and variations thereof found are trademarks
            owned by the Author and all use of these marks inures to the benefit
            of the Author. All rights (including goodwill and, where relevant,
            trade marks) are exclusively owned by us.
          </p>
          <p>
            Subject to the terms hereof, any information or material you transmit
            or post or submit to the App (or otherwise to us) shall be considered
            (and we may treat it as) non-confidential and non-proprietary, subject
            to our obligations under data protection legislation or such
            legislation which provides for protection of electronic data under
            Indian Laws. If for some reason, any part of that statement does not
            work as a matter of law, then for anything which you supply to us from
            whatever source (i.e. via email, the Website or otherwise) you grant
            us a royalty-free, perpetual, irrevocable, non-exclusive right to use,
            copy, modify, adapt, translate, publish and distribute world-wide any
            such material.
          </p>
          <p>
            You hereby fully agree, understand and confirm that each and every
            part of the App, including its contents in form of information,
            comments, suggestions, ideas, graphics, images, etc. as well as the
            underlying software, interactive mechanism etc. as embedded or
            provided in the App are copyrighted and protected intellectual
            property rights of the Author. You are therefore not entitled to copy,
            reproduce, extract or otherwise disseminate any information of the App
            (graphics/ interactivities / 3D model / content) or copy ideas /
            approach / UI design from the App, without prior written permission
            from the Author.
          </p>
          <h4>THIRD PARTY INTELLECTUAL PROPERTY: </h4>
          <p>You agree and acknowledge that Vendors put up pictures and descriptions of the Products which may include the intellectual property of third-party owners. The Author does not claim any proprietary rights over any of the content, trademarks, copyrights designs or any intellectual property rights of such third-party content.</p>
          <p>You acknowledge that, in the event of any third party claim that the content on theApp and use of the App infringes that third party's intellectual property rights, we, will be solely responsible for the investigation, defence, settlement and discharge of any such intellectual property infringement claim.</p>
          <p>	The Author has put in place an IP Take Down Policy so that intellectual property owners can easily report listings that infringe their rights to ensure that infringing Products/content are removed from the App.</p>
          <p>	Only the intellectual property rights owner can report potentially infringing Products or listings through the Take Down Policy by way of Notice of infringement by email to support@ghoshak.com. When raising a complaint for intellectual property infringement, you need to specify your rights, the specific url of the infringement content, a note on how the content infringes your intellectual property rights and provide us with copies of registration certificates or documents based on which you assert your rights.</p>
          <p>If you are not the intellectual property rights owner, you can still help by getting in touch with the rights owner and encouraging them to contact us.</p>


          <h4>INDEMNIFICATION</h4>
          <p>
            You agree to fully indemnify and hold the Author harmless for all
            times to come from any claim or demand, including attorneys’ fees,
            made by any third party against the Author or anybody connected to it
            as a result of (1) any content or information posted or made available
            by you on this App, or (2) any violation of law that occurs by you
            through the App, or (3) anything you do using the App and/or the
            Information contained therein or (4) any reason attributable to you or
            anybody connected to you.
          </p>
          <h4>LIMITATION OF LIABILITY</h4>
          <p>
            You agree that, the aggregate liability of the Author towards you,
            whether under contract, tort or otherwise, shall not, under any
            circumstances and to the fullest extent permitted under the applicable
            law, exceed the actual amount paid by you for downloading or accessing
            the App.
          </p>
          <h4>THIRD PARTY CONTENTS</h4>
          <p>
            The Author is is a distributor (and not a publisher) of content
            supplied by third parties and Users. Accordingly, the Author does not
            have editorial control over such content. Any opinions, advice,
            statements, services, offers, or other information or content
            expressed or made available by third parties, including third parties
            or any other Users are those of the respective author(s) or
            distributors and not of the Author. Neither the Author nor any
            third-party provider of information guarantees the accuracy,
            completeness, or usefulness of any content, nor its merchantability or
            fitness for any particular purpose. The Author neither endorses nor is
            responsible for the accuracy or reliability of any opinion, advice or
            statement made on the website or the App and under no circumstances
            will the Author be liable for any loss or damage caused by User’s
            reliance on information obtained through the website or the App. It is
            the responsibility of User to evaluate the accuracy, completeness or
            usefulness of any information, opinion, advice etc. or other content
            available. The App may contain links to third-party websites
            maintained by other content providers. These links are provided solely
            as a convenience to you and not as an endorsement by the Author of the
            contents on such third-party websites. The Author expressly disclaims
            any representations regarding the content or accuracy of materials on
            such third-party websites. If the User decides to access linked
            third-party websites, the User does so at his/her own risk. Unless
            otherwise expressly agreed in writing by the Author, you shall not
            provide a hyperlink to the Website from any other website and we
            reserve the right to revoke the consent to any link at any time in our
            sole discretion.
          </p>
          <h4>ADVERTISEMENT</h4>
          <p>	The Author may place advertisements in different locations on the App and /or Website and at different points during use of the Service. These locations and points may change from time to time as per our sole discretion. Advertisement may be delivered by the Author or by a third-party advertiser, who may use cookie on your browser and may inter-alia, use any information relevant thereof. You are free to select or click on advertised goods and services or not as you see fit. The advertisements may be based on your preferences selected on the App or based on your previous transactions. In the event that you have any concerns or complaints regarding the quality, nature or content of advertisements please contact us at support@ghoshak.com. </p>
          
          <h4>	LOYALTY PROGRAMS AND OFFERS</h4>
          <p>The Author may offer promotional discounts and offers for you to access and use for purchase of products / Services with individual vendors on the App. Such loyalty programs, coupons and offers may be issued by the vendor directly or by the Author and may be based on your preferences selected on the App or based on your previous transactions. For all loyalty programs, coupons and offers rendered or provided by the Vendors, the respective Vendor shall be responsible for honoring such offers.</p>
          <p>The Author shall neither be liable nor responsible for any actions or inactions of Vendors or any breach of conditions, representations or warranties by the Vendor or manufacturer of the Products. The Author does not sell or retail any Products and does not ensure you or other customers shall perform their obligations in respect of the and specific loyalty programs, offers or promotions granted by Vendors.</p>
          <p>If the Author offers a specific loyalty program or coupon or offer, any concerns or complaints relating to such offers can be reported to support@ghoshak.com </p>



          <h4>INVALIDITY</h4>
          <p>
            If any provision of this Agreement is held to be invalid or
            unenforceable in whole or in part in any jurisdiction, then that
            provision shall be deemed ineffective in such jurisdiction to the
            limited extent, but shall have no effect on the enforceability of the
            remaining provisions.
          </p>
          <p>
            You hereby acknowledge that this Agreement represents the entire
            understanding between you and the Author concerning your use of the
            App and the Information contained therein.
          </p>
          <p>
            The Author may, in the Author’s sole and absolute discretion, modify
            the terms and conditions of this Agreement in whole or in party at any
            time for any reason without any notice to you, whether prior or
            otherwise. Such modified terms and conditions shall supersede these
            terms and conditions and shall become binding when published online on
            the App.Such modifications may include, among other things, the adding
            of certain fees or charges. It is therefore suggested to re-read the
            important terms, notice etc from time to time. If you continue to
            access, download or use the App, you are implicitly agreeing to the
            amended Terms of Use and Privacy Policy. Unless specified otherwise,
            any such modifications thereof shall be effective immediately upon the
            author the author and / or anybody connected to it including but not
            limited toposting of any contents, the information services will be
            deemed to constitute acceptance of the new terms and conditions. The
            author may immediately terminate these Terms or any Services with
            respect to you, or generally cease offering or deny access to the App
            or any portion thereof, at any time for any reason.
          </p>
          <h4>WAIVER</h4>
          <p>
            The Author’s failure to exercise or enforce any right or provision of
            this Agreement shall not be deemed to be a waiver of such right or
            provision.
          </p>
          <h3>DISPUTE RESOLUTION, GOVERNING LAW AND JURISDICTION</h3>
          <p>
            Any dispute arising out of the download, access or use of the App or
            in any manner connected to the App between you and the Author, under
            this Agreement or otherwise, shall be resolved through arbitration
            under the provisions of the Indian Arbitration and Conciliation Act,
            1996 (including any statutory modifications, amendments etc.) by a
            sole arbitrator to be appointed by the Author. The venue of the
            arbitration shall be at Chennai, India and the arbitration proceedings
            shall be conducted in English Language.
          </p>
          <p>
            This Agreement is construed, governed and interpreted in accordance
            with the laws of Union of India and courts at Chennai, India alone
            shall have exclusive competent jurisdiction. In this regard, you
            confirm that you have specifically agreed to the above stipulations of
            the Dispute Resolution as well as the stipulations of this clause
            Governing Law and Jurisdiction along with other terms and conditions
            of this Agreement before agreeing to download, access or use the App
            and therefore you shall not be entitled to raise any objections in
            respect of the said stipulations whether on the ground of
            inconvenience of otherwise.It is also clarified that the services and
            any purchase are directed solely at those who access the Website from
            the Republic of India. The Author makes no representation that
            services (or any goods or services) are available or otherwise
            suitable for use outside the Republic of India. If you choose to
            access the App or use the services from locations outside the Republic
            of India, you do so on your own initiative and are responsible for the
            consequences thereof.
          </p>
          <h4>IMPORTANT</h4>
          <p>
            The above terms and conditions are independent and are in addition to
            the terms and conditions that may be applicable for the usage / access
            of any particular website, E-shop etc. from which you download or
            access the App.
          </p>
          <p>
            YOU CONFIRM THAT YOU HAVE READ THROUGH THE ABOVE TERMS AND CONDITIONS,
            UNDERSTOOD THEM FULLY AND AGREE TO ACCEPT AND COMPLY WITH THE SAME AND
            ACCORDINGLY YOU CLICK “I ACCEPT” BEFORE YOU GO FORWARD TO DOWNLOAD,
            ACCESS OR USE THE APP. In case you have any questions regarding the
            terms, you may contact the concerned as provided in the Contacts
            section.
          </p>
          <div class="vertical-space-60"></div>
        </div>
      </div>
       <Footer></Footer>

      <Modal className="our-client-video-modal" show={show} onHide={handleClose} closeButton>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <iframe width="420" height="345" src="https://www.youtube.com/embed/i-33DB3lsz8"></iframe>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default App;
